import { render, staticRenderFns } from "./ScreenUpload.vue?vue&type=template&id=211e7ad7&scoped=true&"
import script from "./ScreenUpload.vue?vue&type=script&lang=js&"
export * from "./ScreenUpload.vue?vue&type=script&lang=js&"
import style0 from "./ScreenUpload.vue?vue&type=style&index=0&id=211e7ad7&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211e7ad7",
  null
  
)

export default component.exports